import {
  faInfoCircle,
  faUndo,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Col,
  Row,
  Label,
  Alert,
  InputGroupAddon,
  Input,
  InputGroup,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import NumberFormat from "react-number-format";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import ProfileBanner from "../properties/profile/ProfileBanner";
import ButtonIcon from "../common/ButtonIcon";
import SupportLink from "../root/support/components/SupportLink";
import { toInteger } from "lodash";

const VigilantShow = () => {
  const history = useHistory();
  const { role } = useSelector((state) => state.auth.user);
  const params = useParams();
  const { state } = useLocation();
  const vigilant = state ? state.vigilant : null;
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [prefix, setPrefix] = useState("V");
  const [dnia, setDniA] = useState(null);

  useEffect(() => {
    let isMounted = true;
    isMounted && setData(vigilant);
    isMounted && setIsLoading(false);
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (data.dni) {
      setDniA(toInteger(data.dni.substring(1, 40)));
      setPrefix(vigilant?.dni.charAt(0));
    }
  }, [data.dni]);

  return (
    <>
      <PageHeader
        title="Detalle de vigilante"
        titleTag="h2"
        description={"Ve la información del vigilante"}
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <ProfileBanner
        firstname={data.firstname}
        lastname={data.lastname}
        direction={data.address}
        image={data.image}
        edit={false}
      >
        <PreloadState cond={!!data.dni} loading={isLoading}>
          <Or value={true}>
            <hr />
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="form-group">
                        <label htmlFor="startDate">Usuario</label>
                        <div className="rdt">
                          <Label type="text" className="form-control">
                            {data.username}
                          </Label>
                        </div>

                        <Alert color="info">
                          <p className="mb-0">
                            La contraseña por defecto es el <b>DNI</b> . Por
                            ejemplo, si el tipo de documento es "E" y la cédula
                            es "1234567", la contraseña por defecto sería
                            "E01234567".
                          </p>
                        </Alert>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Row>
                      <Col xs={12} className="form-group">
                        <label htmlFor="startDate">DNI</label>
                        <div className="rdt">
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <Input
                                value={prefix}
                                type="select"
                                disabled={true}
                                onChange={(e) => {
                                  setPrefix(e.target.value);
                                }}
                              >
                                <option value="V">V</option>
                                <option value="E">E</option>
                                <option value="J">J</option>
                              </Input>
                            </InputGroupAddon>
                            <NumberFormat
                              disabled={true}
                              className="form-control"
                              value={data.dni || undefined}
                              onValueChange={({ value }) => {
                                setDniA(value);
                              }}
                              thousandSeparator={false}
                              renderText={(value, props) => (
                                <div {...props}>{value}</div>
                              )}
                            />
                          </InputGroup>
                          {/*       <Label type="text" className="form-control">
                            {data.dni}
                          </Label> */}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Row>
                      <Col xs={12} className="form-group">
                        <label htmlFor="startDate">Teléfono</label>
                        <div className="rdt">
                          <Label type="text" className="form-control">
                            {data.phone}
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="form-group">
                        <label htmlFor="startDate">Dirección</label>
                        <div className="rdt">
                          <Label type="text" className="form-control">
                            {data.address}
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-content-end">
                    <ButtonIcon
                      color="falcon-default"
                      className="ml-auto px-5 mr-2"
                      icon={faUndo}
                      onClick={() => history.goBack()}
                      iconAlign="right"
                      transform="down-1 shrink-4"
                    >
                      Volver
                    </ButtonIcon>
                    {role === "manager" && (
                      <ButtonIcon
                        color="primary"
                        className="px-5 ml-2"
                        icon={faUpload}
                        onClick={() =>
                          history.push(
                            `/dashboard/security/vigilants/${params.id}/edit`,
                            { vigilant: vigilant }
                          )
                        }
                        iconAlign="right"
                        transform="down-1 shrink-4"
                      >
                        Actualizar
                      </ButtonIcon>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Or>
          <Message
            value={false}
            color="danger"
            className="p-3"
            icon={faInfoCircle}
          >
            No hay datos para mostrar
          </Message>
        </PreloadState>
      </ProfileBanner>
    </>
  );
};

export default VigilantShow;
